"use client"

import styled from "@emotion/styled"
import { Location3Icon, UserIcon } from "../icons"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.port.grey};
`

const StyledName = styled.h1`
  margin: 0;
  font-size: 36px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -1.2px;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  text-transform: capitalize;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 60px;
    letter-spacing: -2px;
  }
`

const StyledInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

const StyledInfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledDescription = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

type RoomHeaderProps = {
  name: string
  address: string
  capacity: string
  description: string
}

export default function RoomHeader({ name, address, capacity, description }: RoomHeaderProps) {
  return (
    <StyledSection>
      {name && <StyledName>{name}</StyledName>}
      <StyledInfoGroup>
        {address && (
          <StyledInfoRow>
            <Location3Icon />
            <span>{address}</span>
          </StyledInfoRow>
        )}
        {capacity && (
          <StyledInfoRow>
            <UserIcon />
            <span>{capacity}</span>
          </StyledInfoRow>
        )}
      </StyledInfoGroup>
      {description && <StyledDescription>{description}</StyledDescription>}
    </StyledSection>
  )
}
